import React from 'react'
import {
  Button,
  AnimationWrapper,
  Input
} from '..'
import { Parallax } from 'react-scroll-parallax'
import PropTypes from 'prop-types'
import { Col, Row } from 'react-styled-flexboxgrid'
import system10 from '../../../assets/system10.svg'
import sqlRocketAnimation from '../../lottie-animations/sql-rocket.json'
import futuriceFamily from '../../../assets/futurice-family.svg'
import * as styles from './styles'

const propTypes = {
  content: PropTypes.object.isRequired
}

const Landing = (props) => {
  const { content } = props
  return (
    <styles.IntroContainer>
      <styles.IntroSection>
        <Row>
          <Col xs={12} sm={6}>
            <styles.IntroHeader>
              { content.header }
              <br />
              <span className="nowrap">{ content.headerNoWrapPart }</span>
            </styles.IntroHeader>
            <styles.IntroTagline>
              { content.tagline }
            </styles.IntroTagline>

            <styles.IntroTagline>
              { content.footerTagline }
            </styles.IntroTagline>

            <styles.RequestAccessFormContainer>
              <form method="POST" target="_blank" action="https://aito.us18.list-manage.com/subscribe/post">
                <input type="hidden" name="u" value="e7ff1392b78623cfdcbda17c8" />
                <input type="hidden" name="id" value="305bbc6e91" />
                {/*
                  Autogenerated by mailchimp:
                  "Real people should not fill this in and expect good things - do not remove this
                  or risk form bot signups"
                  */}
                <div style={{ position: 'absolute', left: '-5000px', ariaHidden: 'true' }}>
                  <input
                    type="text"
                    name="b_e7ff1392b78623cfdcbda17c8_305bbc6e91"
                    tabIndex="-1"
                  />
                </div>
                {/* These names need to match the configuration in Mailchimp */}
                <styles.CustomForm>
                  <Input name="EMAIL" type="email" required inputStyle="square" placeholder="Your email address" />
                  <Button size="small" type="submit">Request early access</Button>
                </styles.CustomForm>
              </form>
            </styles.RequestAccessFormContainer>
          </Col>

          <Col xs={12} sm={6}>
            <styles.IntroSectionAnimationCenterer>
              <styles.IntroSectionAnimationContainer>
                <AnimationWrapper animation={sqlRocketAnimation} pauseAt={1.68} />
              </styles.IntroSectionAnimationContainer>
            </styles.IntroSectionAnimationCenterer>
          </Col>
        </Row>

        <styles.LogoContainer>
          <a href="https://futurice.com" target="_blank" rel="noopener noreferrer"><img src={futuriceFamily} alt="a company by Futurice" /></a>
        </styles.LogoContainer>
      </styles.IntroSection>

      <Parallax y={['-30px', '30px']}>
        <styles.IntroSectionSideSquare src={system10} alt="" />
      </Parallax>
    </styles.IntroContainer>
  )
}

Landing.propTypes = propTypes

export default Landing
